export const TERM_NAME = "paymentTermName";
export const DESCRIPTION = "description";
export const PERCENT = "percent";
export const COMMUNITY_ID = "communityId";
export const DAYS = "days";
